angular.module('services.localizedMessages', []).factory('localizedMessages', ['$interpolate', 'I18N.MESSAGES', function ($interpolate, i18nmessages) {

	var handleNotFound = function (msg, msgKey) {
		return msg || '?' + msgKey + '?';
	};

  return {
    get : function (msgKey, interpolateParams) {
      let key = navigator.language || navigator.userLanguage || 'en';
      key = key.split("-")[0];
      var msg =  i18nmessages[key][msgKey];
      if (msg) {
        return $interpolate(msg)(interpolateParams);
      } else {
        return handleNotFound(msg, msgKey);
      }
    }
  };
}]);


// WEBPACK FOOTER //
// ./client/src/common/services/localizedMessages.js